<div class="equipment-main-page">
  <div class="equipment-main-page__container">
    <button class="vox-btn vox-btn-secondary equipment-main-page__add-equipment" (click)="openAddEquipmentPopup()" translate>equipment.add-button</button>
    <div class="equipment-main-page__filters">
      <gdp-equipment-filters (filtersChanged)="filterChanged($event)" [filters]="filters" [limitedAvailableFilters]="limitedAvailableFilters" ></gdp-equipment-filters>
    </div>
    <div class="equipment-main-page__table">
      <gdp-equipment-table [equipmentList]="equipmentList" [loading]="loading" [loadingLines]="loadingLines"></gdp-equipment-table>
    </div>
    <div class="equipment-table-page__pagination">
      <gdp-table-pagination (onSelectPageSize)="selectPageSize($event)" (onChangeCurrentPage)="changeCurrentPage($event)" [totalPages]="pagination.totalPages" [pagination]="pagination" [selectedPageSize]="pageSize"></gdp-table-pagination>
    </div>
  </div>
</div>
